import { get as apiGet, post } from 'api'
export const getAll = async ({ status, sefStatus, crfStatus, documentType, ...request }) =>
  apiGet('/folder/getlist', {
    statusList: status,
    sefStatusList: sefStatus,
    crfStatusList: crfStatus,
    documentTypeList: documentType,
    ...request,
  })

export const getMyActivities = async ({ sefStatus, crfStatus, documentType, ...request }) =>
  apiGet('/myActivities/byStatus', {
    sefStatusList: sefStatus,
    crfStatusList: crfStatus,
    documentTypeList: documentType,
    ...request,
  })

export const getUndipatched = async tableState => apiGet('/myActivities/undispatched', tableState)

export const get = async (id, createTime) => apiGet(`/folder/${id}`, { createTime })

export const getNavigation = async ({ sefStatus, crfStatus, statusList, documentType, status, ...request }) => {
  return apiGet(`/folder/getNavigation`, {
    sefStatusList: sefStatus,
    crfStatusList: crfStatus,
    documentTypeList: documentType,
    status: status ?? statusList,
    statusList: statusList,
    ...request,
  })
}

export const create = async ({ archiverId, ...values }) =>
  post('/folder/create', {
    archiverInvoiceId: archiverId,
    ...values,
  })

export const update = async values => post('/folder/setCustomer', values)
export const massJobs = async values => post('/massjobs', values)
export const validate = async values => post('/massjobs/validate', values)

export const getAllStatuses = async () => apiGet('/folder/getallstatuses')

export const getFoldersCountByStatus = async (dateRange) => {
  const params = new URLSearchParams()
  if (dateRange?.startDateTime) {
    params.set('startDateTime', dateRange.startDateTime)
  }
  if (dateRange?.endDateTime) {
    params.set('endDateTime', dateRange.endDateTime)
  }
  const queryString = params.toString()
  return apiGet(`/myActivities/countsByStatus${queryString ? `?${queryString}` : ''}`)
}
